import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { TBaseTagContext } from '../types';
import { TTag } from './types';
import { validate } from '@krugom/validator';
import { toString } from 'lodash';

export const CustomMarkdown: React.FC<{
  tagProps: TTag;
  context: Partial<TBaseTagContext>;
}> = React.memo(({ tagProps, context }) => {
  const validationScheme = useMemo(
    () => ({
      type: 'object',
      properties: {
        children: {
          type: 'string',
          required: true,
        },
      },
    }),
    []
  );

  const result = useMemo(() => validate(tagProps, validationScheme), [tagProps, validationScheme]);

  if (!result.isValid) {
    console.error(
      'Тэг: $Markdown;',
      `Путь: ${context.path?.join('.') || 'Не указан'};`,
      result.errors
    );
    return <>{toString(tagProps.children)}</>;
  }

  return (
    <ReactMarkdown rehypePlugins={tagProps.raw ? [rehypeRaw] : undefined}>
      {`${tagProps.children}`}
    </ReactMarkdown>
  );
});

CustomMarkdown.displayName = 'CustomMarkdown';
